import UltMeta, { Meta } from "./UltMeta/index";

class ProjectState extends UltMeta {
    STAY_ASSIGN = new Meta(1, "待处理"); // 小程序对应 待处理
    PENDING = new Meta(2, "处理中"); // 小程序对应 处理中
    PROCESSING = new Meta(3, "交付中"); // 小程序对应 交付中
    // DRAFT = new Meta(4, "草稿"); // 小程序对应 草稿
    FINISHED = new Meta(5, "已完成", "color-info"); // 小程序对应 已完成
    // CLOSED = new Meta(6, "已关闭", "color-info"); // 小程序对应 已关闭
}

export const PROJECT_STATE = new ProjectState();

class ProjectTabItems extends UltMeta {
    PROJECT_INFO = new Meta(1, "项目信息");
    // CONTRACT_INFO = new Meta(2, "合同信息", "ContractInfo");
    PAYMENT_INFO = new Meta(3, "收付款明细", "PaymentInfo");
    DELIVERY_INFO = new Meta(4, "提货申请", "DeliveryInfo");
    SIGN_INFO = new Meta(5, "签收明细", "ReceiptInfo");
    RECONCILIATION_INFO = new Meta(6, "对账明细", "ReconciliationInfo");
    SERVICE_COST_INFO = new Meta(7, "服务费明细", "BillDetail");
    BILLING_INFO = new Meta(8, "开票明细", "InvoiceInfo");
}

export const PROJECT_TAB_ITEMS = new ProjectTabItems();

class ProjectType extends UltMeta {
    ONLINE = new Meta(1, "线上");
    OFFLINE = new Meta(2, "线下");
}

export const PROJECT_TYPE = new ProjectType();
